/**
 * @param {string} promocode
 */
import { getUtmParameters } from "./utm.js";

/**
 * @param {string} promoCode
 * @returns {Promise<{transactionChannel: (string|string|*), transactionPromocode}>}
 */
export function createAdmitad(promoCode) {
  return Promise.resolve({
    transactionChannel: promoCode.startsWith('adm') ? 'adm' : getUtmParameters().source,
    transactionPromocode: promoCode
  });
}
